import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-6 py-6" }
const _hoisted_2 = { class: "text-lg font-medium my-auto flex-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "sr-only" }
const _hoisted_8 = { class: "rounded flex py-4 px-6 gap-x-4 odd:bg-dark-gray-200 font-semibold" }
const _hoisted_9 = {
  key: 0,
  class: "px-6 pb-6 text-sm text-gray-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCheckbox = _resolveComponent("CustomCheckbox")!
  const _component_ActivityTableModal = _resolveComponent("ActivityTableModal")!
  const _component_EllipsisVertical = _resolveComponent("EllipsisVertical")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DropdownMenuTrigger = _resolveComponent("DropdownMenuTrigger")!
  const _component_DropdownMenuItem = _resolveComponent("DropdownMenuItem")!
  const _component_DropdownMenuContent = _resolveComponent("DropdownMenuContent")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_CustomTable = _resolveComponent("CustomTable")!
  const _component_ApproveDifferenceModal = _resolveComponent("ApproveDifferenceModal")!
  const _component_MainViewCard = _resolveComponent("MainViewCard")!

  return (_openBlock(), _createBlock(_component_MainViewCard, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.data.title), 1),
        (_ctx.data.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.data.subtitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_CustomTable, {
        headers: _ctx.computedHeaders,
        items: _ctx.data.items,
        "row-class": _ctx.getRowBackgroundClass
      }, {
        action: _withCtx(({ header, getWidth, getItemProperty, getHeaderClass, item }) => [
          (_openBlock(), _createElementBlock("td", {
            key: header.value,
            class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words min-h-6.5`),
            style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
          }, [
            _createElementVNode("div", _hoisted_4, [
              (item.row_type === 'difference')
                ? (_openBlock(), _createBlock(_component_CustomCheckbox, {
                    key: 0,
                    checked: _ctx.hasComment,
                    "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCheckboxChange($event)))
                  }, null, 8, ["checked"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(getItemProperty(header, item)), 1),
                (item.weight_derived)
                  ? (_openBlock(), _createElementBlock("sup", _hoisted_5, "(*)"))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 6))
        ]),
        amount: _withCtx(({ header, getWidth, getItemProperty, getHeaderClass, item }) => [
          (_openBlock(), _createElementBlock("td", {
            key: header.value,
            class: _normalizeClass(`${getHeaderClass(header, false)} ${_ctx.hasActivityRecords(item) ? 'underline' : ''} my-auto break-words min-h-6.5`),
            style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
          }, [
            _createVNode(_component_ActivityTableModal, {
              title: _ctx.$t('views.reports.reportsPage.tables.departures.activitiesModalHeader'),
              "record-type-ids": item.record_type_ids,
              "fct-object-ids": item.fct_object_ids,
              records: _ctx.records,
              onFetchRecords: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('fetch-records')))
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'cursor-pointer': _ctx.hasActivityRecords(item) }),
                  onClick: ($event: any) => (_ctx.hasActivityRecords(item) && scope.open())
                }, _toDisplayString(getItemProperty(header, item)), 11, _hoisted_6)
              ]),
              _: 2
            }, 1032, ["title", "record-type-ids", "fct-object-ids", "records"])
          ], 6))
        ]),
        weight: _withCtx(({ header, getWidth, getItemProperty, getHeaderClass, item }) => [
          (_openBlock(), _createElementBlock("td", {
            key: header.value,
            class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words min-h-6.5`),
            style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
          }, _toDisplayString(getItemProperty(header, item)), 7))
        ]),
        average_weight: _withCtx(({ header, getWidth, getItemProperty, getHeaderClass, item }) => [
          (_openBlock(), _createElementBlock("td", {
            key: header.value,
            class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words min-h-6.5`),
            style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
          }, _toDisplayString(getItemProperty(header, item)), 7))
        ]),
        actions: _withCtx(({ header, getWidth, getHeaderClass, item }) => [
          (item.row_type === 'difference')
            ? (_openBlock(), _createElementBlock("td", {
                key: header.value,
                class: _normalizeClass(`${getHeaderClass(header, false)} my-auto min-h-6.5`),
                style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
              }, [
                _createVNode(_component_DropdownMenu, { modal: false }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DropdownMenuTrigger, { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconButton, {
                          variant: "ghost",
                          size: "icon",
                          class: "rounded-full h-6 w-6 -mr-[9px]"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('views.reports.reportsPage.tables.actions')), 1),
                            _createVNode(_component_EllipsisVertical, {
                              class: "size-4",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DropdownMenuContent, { align: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DropdownMenuItem, {
                          class: "cursor-pointer font-medium",
                          onClick: _ctx.openModal
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.tables.edit')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 6))
            : (_openBlock(), _createElementBlock("td", {
                key: `${header.value}-empty`,
                class: _normalizeClass(`${getHeaderClass(header, false)} my-auto min-h-6.5`),
                style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
              }, null, 6))
        ]),
        "append-rows": _withCtx(({ getWidth, getItemProperty, getHeaderClass }) => [
          _createElementVNode("tr", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedHeaders, (header) => {
              return (_openBlock(), _createElementBlock("td", {
                key: header.value,
                class: _normalizeClass(`${getHeaderClass(header, false)} my-auto break-words min-h-6.5`),
                style: _normalizeStyle(`max-width: ${getWidth(header)}px; width: 100%;`)
              }, _toDisplayString(getItemProperty(header, _ctx.data.total)), 7))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["headers", "items", "row-class"]),
      (_ctx.showFootnote)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "(*) " + _toDisplayString(_ctx.data.footnote), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_ApproveDifferenceModal, {
        ref: "approveModal",
        "existing-comment": _ctx.commentDifference,
        onSave: _ctx.onCommentSaved
      }, null, 8, ["existing-comment", "onSave"])
    ]),
    _: 1
  }))
}